export const calcPercent = (num: number, perc: number) => {
    return num * (perc / 100)
}